<template>
    <!--会员类别-->
    <el-select :multiple="multiple" :clearable="clearable"   :disabled="disabled" :value="value"   @visible-change="visiblechange"  @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item in list"
                :key="item.cardTypeCode"
                :label="item.cardTypeName"
                :value="item.cardTypeCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "member-type-list",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            disabled:Boolean,
            clearable:Boolean,
            value:[Array,Object,String],
            // type:String
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
                data:'',
            }
        },
        watch:{
            value(newval,oldval){
                // if(!newval&&this.type=='object'){
                //     this.data=null;
                // }else

            }
        },
        mounted(){
            this.getData();

        },
        methods:{
            getData(){
                this.$axios.post("/card/memberTypeList/",{
                    "storeId":this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log(res.data.list)
                    this.list=res.data.list;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            visiblechange(isshow){
                if(isshow){
                    this.getData();
                }
            },
            change(value){
                console.log(value)
                if(value){
                    if(this.multiple){
                        var a=[];
                        this.list.filter((item)=>{
                            for(var i in value){
                                if(item.cardTypeCode==value[i]){
                                    a.push(item);
                                    break;
                                }
                            }
                        });
                        this.$emit('change',a);

                    }else{
                        var data= this.list.filter((item)=>item.cardTypeCode==value);
                        this.$emit('change',data[0]);
                    }

                }else{

                    this.$emit('change',value);
                }
                this.$emit('input',value);
            }
        }
    }
</script>

<style scoped>

</style>